import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { IS_SPINNER_ACTIVE } from '../../../../../util/interceptors';
import { Injectable } from '@angular/core';
import { UrlService } from '../../../../../../environments/urlService';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'terms-and-conditions/';
  }

  getLastUpdateTermAndCondition(): Observable<Date> {
    return this.http.get<Date>(
      this.url + 'last',
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      });
  }

  setAgreement(): Observable<void> {
    return this.http.post<void>(
      this.url + 'set-agreement', null,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
      });
  }
}
